<script>
import Layout from '@layouts/main.vue'
import BasePopover from '@components/_base-popover.vue'
import BaseVidPLayer from '@components/_base-vidplayer.vue'
import BaseConnections from '@components/_base-conections.vue'
import VideoModal from '@components/video-modal.vue'
import BlankButton from '@components/blank-button.vue'

export default {
  page: {
    title: '02 01 Planning Location A',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Location Page.' },
    ],
  },
  components: {
    Layout,
    BasePopover,
    BaseVidPLayer,
    BaseConnections,
    VideoModal,
    BlankButton,
  },

  data() {
    return {
      disPlayVideo: false,
      refresh: 0,
    }
  },
  methods: {
    nextSlide() {
      const vidComp = this.$refs.bgVideo
      this.fadeStage()
      vidComp.onPlay()
    },
    openModal() {
      this.disPlayVideo = true
      this.refresh++
    },
    closedModal() {
      this.disPlayVideo = false
    },
    fadeStage() {
      this.$refs.fadeStage.classList.add('go')
    },
  },
}
</script>

<template>
  <Layout
    :way-number="1"
    way-name="Planning"
    next-loc="Location B"
    next-title="EXPLORATION DRILLING"
    :hide-back="true"
  >
    <BlankButton
      blank-height="125px"
      blank-width="255px"
      blank-x="0"
      blank-y="65px"
      @click.native="nextSlide"
    />
    <BaseVidPLayer
      ref="bgVideo"
      src="1A_DrillholeDesign.mp4"
      poster="journey1-A.png"
      next-path="01-B-exploration-drilling"
      :pause="5"
    />
    <div ref="fadeStage" class="fadeStage">
      <BaseConnections d-val="M0,0, L14.5,38, L20,100" />
      <BasePopover
        pos-orient="bottom-left"
        :position="[500, 200]"
        id-name="box1"
        class-name="box1Class"
        box-color="white"
        hotspot-id="hotspotting"
        hotspot-class="hotspotting"
        :hot-spot-x="13.7"
        :hot-spot-y="48"
        :delay-start="10"
      >
        <div class="flex m-b-15">
          <div class="m-r-10">
            <img
              :src="require('@assets/images/map-icon.png')"
              alt="map-icon"
              style="height: 55px;"
            />
          </div>
          <div>
            <h5>02 PLANNING: LOCATION A</h5>
            <h2>PLANNING</h2>
          </div>
        </div>
        <p>
          Create, design and share exploratory<br />
          drill plans from a single source.<br /><br />
          Combine data to create a comprehensive <br />
          resource model.
        </p>
      </BasePopover>

      <BasePopover
        pos-orient="top-left"
        :position="[450, 550]"
        id-name="box2"
        class-name="box2Class"
        box-color="black"
        hotspot-id="hotspot2"
        hotspot-class="hotspot2"
        :hot-spot-x="13.7"
        :hot-spot-y="48"
        :delay-start="5000"
      >
        <div @click="openModal">
          <img :src="require('@assets/images/vid-placeholder.png')" />
        </div>
      </BasePopover>
      <BaseHotspot
        ref="contentSpot"
        spot-size="mid"
        :pos-x="10"
        :pos-y="41"
        pos-unit="%"
        :rot-x="27"
        spot-active="active"
        :fade-time="500"
      />
      <VideoModal :key="refresh" :display="disPlayVideo">
        <Button type="primary" class="closeBtn" @click="closedModal">X</Button>
        <video
          ref="videoPlayerModal1"
          width="100%"
          height="100%"
          :src="require('@assets/videos/journey-2.mp4')"
          autoplay
        ></video>
      </VideoModal>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

.fadeStage {
  opacity: 1;
  transition: opacity 1s;

  &.go {
    opacity: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 5.9s;
}
.fade-enter,
.fade-leave-to,
.fade-leave-active b {
  opacity: 0;
}
</style>
